import React, { useState } from 'react';
import { Button, Drawer, Textarea } from 'tdesign-react';
import type { TextareaProps } from 'tdesign-react/lib/textarea';

import styles from './index.module.less';

export const TextareaComponent: React.FC<
{
  value: string;
  btnContext: string;
  valueShow?: string;
  valueType?: 'string' | 'json';
  showDrawer?: boolean;
  labelText?: string;
  onChange: (key: string) => void;
  onBtnClick: (value: string[]) => void;
} & TextareaProps
> = ({ ...props }) => {
  const { value = '', labelText = '', showDrawer } = props;
  const [visible, setVisible] = useState(false);

  const triggeredClose = () => {
    setVisible(!visible);
  };

  return (
    <div className={styles.textWrapper}>
      <Textarea
        autosize={{ minRows: 3, maxRows: 10 }}
        {...props}
        value={value}
      />
      {
        showDrawer
          ? <Button
            className={styles.button}
            theme="default"
            variant="text"
            size="small"
            onClick={triggeredClose}
          >
            展开
          </Button>
          : null
      }
      <Drawer
        header={labelText}
        size={'600px'}
        visible={visible}
        onClose={triggeredClose}
        footer={false}
        destroyOnClose>
        <Textarea
          className={styles['custom-textarea']}
          {...props}
          autosize={{ minRows: 10 }}
          value={value}
        />
      </Drawer>
    </div>
  );
};
